import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import ServicePage from "@/pages/ServicePage";

export const Route = createFileRoute("/es/servicios/regulatory-affairs/")({
  head: () => buildRouteHead("/es/servicios/regulatory-affairs"),
  component: ServicePage,
});

